import { Component, ElementRef, AfterViewInit } from '@angular/core';
import { ThreatMetrixService } from '../../services/threat-metrix.service';

@Component({
  selector: '[data-component=threat-metrix]',
  templateUrl: './threat-metrix.component.html',
})
export class ThreatMetrixComponent implements AfterViewInit {
  constructor(
    private elementRef: ElementRef,
    private threatMetrixService: ThreatMetrixService
  ) {}

  ngAfterViewInit() {
    this.insertScript();
  }

  private insertScript() {
    if (!this.threatMetrixService.enabled) return;

    const newScriptElement = document.createElement('script');
    newScriptElement.setAttribute('id', 'tmx');
    newScriptElement.setAttribute('src', this.createScriptSrc());
    newScriptElement.setAttribute('type', 'text/javascript');

    this.elementRef.nativeElement.appendChild(newScriptElement);
  }

  private createScriptSrc(): string {
    const sessionId = this.threatMetrixService.newSessionId();
    const orgId = this.threatMetrixService.orgId;
    const pageId = 'eServicing';
    return `https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=${sessionId}&pageid=${pageId}&allow_reprofile=1`;
  }
}
